import * as React from 'react'
import './carrot-down.css'

export const CarrotDown = (props: any) =>
<svg xmlns="http://www.w3.org/2000/svg" id="Chevron_Right" width={props.svgwidth || 13.656} height={props.svgheight || 7.52} viewBox="0 0 13.656 7.519">

    <path id="Chevron_Right-2" d="M.2 7.316l6.141 6.139a.69.69 0 0 0 .976-.974L1.663 6.829l5.653-5.653A.69.69 0 0 0 6.34.2L.2 6.341a.7.7 0 0 0 0 .975z" className={props.black ? 'carrot-up-black' : 'carrot-down-1'}  data-name="Chevron_Right" transform="rotate(-90 3.76 3.76)"/>
</svg>
